import { AxisEnum } from '../models/enums/AxisEnum';
import { Box } from '../models/other/box.model';

export function topLeftObjectCornerPositionToKonvaPosition(value: number, axis: AxisEnum, box: Box, rotation: number): number {
    let posX = 0, posY = 0;
    switch (rotation) {
        case 90:
            if (axis === AxisEnum.X) {
                posX = value + box.length;
            } else {
                posY = value;
            }
            break;
        case 180:
            if (axis === AxisEnum.X) {
                posX = value + box.width;
            } else {
                posY = value + box.length;
            }
            break;
        case 270:
            if (axis === AxisEnum.X) {
                posX = value;
            } else {
                posY = value + box.width;
            }
            break;
        // default is rotation 0
        default:
            if (axis === AxisEnum.X) {
                posX = value;
            } else {
                posY = value;
            }
            break;
    }

    if (axis === AxisEnum.X) {
        return posX;
    } else {
        return posY;
    }
}

export function konvaPositionToTopLeftObjectCornerPosition(value: number, axis: AxisEnum, box: Box, rotation: number): number {
    let posX = 0, posY = 0;
    switch (rotation) {
        case 90:
            if (axis === AxisEnum.X) {
                posX = value - box.length;
            } else {
                posY = value;
            }
            break;
        case 180:
            if (axis === AxisEnum.X) {
                posX = value - box.width;
            } else {
                posY = value - box.length;
            }
            break;
        case 270:
            if (axis === AxisEnum.X) {
                posX = value;
            } else {
                posY = value - box.width;
            }
            break;
        // default is rotation 0
        default:
            if (axis === AxisEnum.X) {
                posX = value;
            } else {
                posY = value;
            }
            break;
    }

    if (axis === AxisEnum.X) {
        return posX;
    } else {
        return posY;
    }
}